// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3QGnM","requiredAsterisk":"Info_requiredAsterisk__3H7LI"};